import { render, staticRenderFns } from "./ValidationErrors.vue?vue&type=template&id=37be6300&scoped=true"
import script from "./ValidationErrors.vue?vue&type=script&lang=js"
export * from "./ValidationErrors.vue?vue&type=script&lang=js"
import style0 from "./ValidationErrors.vue?vue&type=style&index=0&id=37be6300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37be6300",
  null
  
)

export default component.exports